import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import {
  AttributeFieldsContext,
  useAttributeFieldsContextValue,
} from 'src/containers/ProjectMapping/hooks/attributes';
import {
  SuggestionsContext,
  useSuggestionContextValue,
} from 'src/containers/ProjectMapping/hooks/suggestion';
import { ProjectClassMappingAttributesSection } from 'src/containers/ProjectMapping/ProjectClassMappingAttributesSection';
import { ProjectClassMappingHeader } from 'src/containers/ProjectMapping/ProjectClassMappingHeader';
import { ProjectClassMappingRelationshipsSection } from 'src/containers/ProjectMapping/ProjectClassMappingRelationshipSection/ProjectClassMappingRelationshipsSection';
import { ProjectClassMappingTopSection } from 'src/containers/ProjectMapping/ProjectClassMappingTopSection';

const ProjectClassMappingInner: React.VFC = () => {
  const attributeContextValue = useAttributeFieldsContextValue();
  return (
    <AttributeFieldsContext.Provider value={attributeContextValue}>
      <div className="sd-project-class-mapping">
        <div className="sd-project-mapping-sticky">
          <ProjectClassMappingHeader />
        </div>

        <div
          className="sd-project-mapping-body"
          data-testid={TEST_IDS.projectMapping.classMapping.list}
        >
          <ProjectClassMappingTopSection />
          <ProjectClassMappingRelationshipsSection />
          <ProjectClassMappingAttributesSection />
        </div>
      </div>
    </AttributeFieldsContext.Provider>
  );
};

export const ProjectClassMapping: React.VFC = () => {
  // `useAttributeFieldsContextValue` uses the `useSuggestionContext` hook,
  // so it must be rendered within the SuggestionsContext provider
  const suggestionContextValue = useSuggestionContextValue();
  return (
    <SuggestionsContext.Provider value={suggestionContextValue}>
      <ProjectClassMappingInner />
    </SuggestionsContext.Provider>
  );
};
